<template>
  <div class="clean-url-box d-flex align-items-center justify-content-between mb-4 p-2 pl-3">
    <div class="url-text font-gradient-a font-weight-bold text-truncate me-3" style="font-size: 14px;" :title="url">
      {{ url }}
    </div>
    <button class="btn btn-sm btn-outline-light copy-btn rounded-pill px-4" @click="copyNow">
      {{ copyLabel }}
    </button>
  </div>
</template>

<script>
export default {
  name: "PremiumUrlBox",
  props: {
    url: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      copied: false,
      copyLabel: 'Copy'
    }
  },
  methods: {
    copyNow() {
      const tempInput = document.createElement("input");
      tempInput.value = this.url;
      document.body.appendChild(tempInput);
      tempInput.select();
      
      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.copied = true;
          this.copyLabel = 'Copied!';
          this.$emit('success', 'Copied!');
        }
      } catch (err) {
        this.$emit('error', 'Oops, unable to copy');
      }
      
      document.body.removeChild(tempInput);
      window.getSelection().removeAllRanges();
      
      setTimeout(() => {
        this.copied = false;
        this.copyLabel = 'Copy';
      }, 5000);
    }
  }
}
</script>

<style scoped>
.clean-url-box {
  background: #1e1e1e;
  border: 1px solid #333;
  border-radius: 50px;
  width: 100%;
}
.clean-url-box .copy-btn {
  background: #2a2a2a;
  border-color: #444;
  color: #fff;
}
.clean-url-box .copy-btn:hover {
  background: #333;
}
</style>
